<header id="header-container" class="w-100">
  <section>
    <div class="mh-section-content d-flex align-items-center justify-content-between py-2">
      <div class="header-item p-0 d-flex align-items-center">
        <button type="button" class="btn btn-link text-white p-0 me-3 d-flex align-items-center d-md-none" (click)="toggleNav.emit()" aria-label="Toggle navigation menu">
          <i class="bi bi-list fs-2" aria-hidden="true"></i>
        </button>
        <img id="header-logo-horizon" [src]="headerContents.logoPath" [alt]="headerContents.altText" class="img-fluid d-none d-md-block" />
        <img id="header-logo-stacked" [src]="headerContents.mediaHeaderLogoPath" [alt]="headerContents.altText" class="img-fluid height-42 d-block d-md-none" />
        <img id="header-logo-separator" src="/assets/images/vertical_line.svg" class="d-block d-md-block px-3" alt="vertical line" />
        <h1 class="text-white title d-block d-md-none font-size-22 mt-2" id="app-header-ic-mh-logo">{{ headerContents.appTitle }}</h1>
      </div>
      <div class="header-item p-0 d-none d-md-block flex-grow-1 title d-flex align-items-center">
        <h1 class="text-white font-size-22 m-0 p-0">{{ headerContents.appTitle }}</h1>
      </div>
      @if (!hideSettings()) {
        <a routerLink="/users">
          <img ngbTooltip="Home" placement="bottom" [autoClose]="true" class="me-3 cursor-pointer" src="/assets/images/home.svg" alt="Home" />
        </a>
      }
      @if (!hideSettings()) {
        <app-user-settings></app-user-settings>
      }
      <!--Show spinner when userSettings is hidden-->
      @if (hideSettings()) {
        <div>
          <div class="flex-grow-1 user-settings-container border-left py-2 px-0">
            <div class="d-flex align-items-center justify-content-center flex-grow-1 ps-4 pe-1">
              <span class="rounded-circle d-flex align-items-center justify-content-center">
                <div class="spinner-border small d-inline-block" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </span>
            </div>
          </div>
        </div>
      }
    </div>
  </section>
</header>
